import { yup } from '@medely/ui-kit';

export const recommendedSpecialtiesFormSchema = yup.object({
  add_specialty_ids: yup.array(),
});
